import React, { useEffect, useRef } from "react";
import '../servicecalendar.css';

export const ServiceCalendarPopupShowColors = ({
    colors,
    displayStyle,
    left,
    top
}) => {
    return (
        <div
            id="showColorsPopup"
            style={{
                width: '11em',
                display: displayStyle,
                left: left,
                top: top,
                position: "absolute",
                background: "white", 
                border: "1px solid lightgrey",
                boxShadow: '5px 4px 4px rgba(10, 10, 10, 0.4)',
                zIndex: "1000"
            }}
        >
            <div style={{ width: '100%', height: '10px', background: 'rgba(36, 119, 168, 1)' }}></div>
            <div style={{ width: '100%', padding: '4px 8px 6px' }}>
                <div style={{ width: '100%' }}>
                    { colors.map((color, index) => (
                        <div 
                            style={{
                                padding: '2px 6px',
                                marginTop: '3px',
                                display: 'flex', 
                                alignItems: 'center', 
                                justifyContent: 'center', 
                                background: color.value ,
                                border: '2px solid ' + color.valueBorder,
                                color: 'white',
                                fontWeight: 'bolder'
                            }}
                        >
                            {color.name}
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};
